import { render, staticRenderFns } from "./live-rank.vue?vue&type=template&id=8b51d2f6&scoped=true&"
import script from "./live-rank.vue?vue&type=script&lang=js&"
export * from "./live-rank.vue?vue&type=script&lang=js&"
import style0 from "./live-rank.vue?vue&type=style&index=0&id=8b51d2f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b51d2f6",
  null
  
)

export default component.exports